/**
 * Drawer-only gift-box grouping and short FLIP motion.
 * Does not change cart APIs, quantities, or paid lines.
 */
(function (root) {
  if (root.NativeCartGiftMotion) return;

  var NATIVE_DRAWER = '#CartDrawer.is-native-cart-custom';
  var OFFER_MOUNT = '[data-native-cart-offer="giftBox"]';
  var DURATION = 220;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var HOME_MARK = 'native-cart-gift-offer-home';
  var GLYPH_CLASS = 'native-cart-gift-glyph';
  var running = [];
  var ghosts = [];
  var liveStyled = [];

  function viewOf(node) {
    var doc = node && node.ownerDocument ? node.ownerDocument : node;
    if (doc && doc.defaultView) return doc.defaultView;
    if (typeof window !== 'undefined') return window;
    return root;
  }

  function nativeDrawerFrom(form) {
    if (!form) return null;
    if (form.closest) {
      var nested = form.closest(NATIVE_DRAWER);
      if (nested) return nested;
    }
    return null;
  }

  function isActiveNativeDrawer(form) {
    return !!nativeDrawerFrom(form);
  }

  function productsRoot(form) {
    return form && form.querySelector ? form.querySelector('[data-products]') : null;
  }

  function offerMount(form) {
    return form && form.querySelector ? form.querySelector(OFFER_MOUNT) : null;
  }

  function attrEscape(value) {
    return String(value == null ? '' : value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function queryByKey(scope, key) {
    if (!scope || !key || !scope.querySelector) return null;
    return scope.querySelector('.cart__item[data-key="' + attrEscape(key) + '"]');
  }

  function isGiftLine(el) {
    return !!(el && el.getAttribute && el.getAttribute('data-native-gift-line') === 'true');
  }

  function isEligibleParent(el) {
    return !!(el && !isGiftLine(el) && el.getAttribute && el.getAttribute('data-native-gift-eligible') === 'true');
  }

  function collectItems(scope) {
    if (!scope || !scope.querySelectorAll) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('.cart__item[data-key]'));
  }

  function matchParent(scope, parentKey, parentVariant, requireEligible) {
    function acceptable(el) {
      if (!el || isGiftLine(el)) return false;
      if (requireEligible) return isEligibleParent(el);
      return true;
    }
    var key = String(parentKey || '').trim();
    var variant = String(parentVariant == null ? '' : parentVariant).trim();
    if (key || variant) {
      var exact = key ? queryByKey(scope, key) : null;
      if (acceptable(exact)) return exact;
      // Discount changes can replace a line key. Never guess between two
      // customizations of the same variant when the exact key is gone.
      if (!variant) return null;
      var candidates = collectItems(scope).filter(function (el) {
        return String(el.getAttribute('data-variant-id') || '') === variant && acceptable(el);
      });
      return candidates.length === 1 ? candidates[0] : null;
    }
    var last = null;
    collectItems(scope).forEach(function (el) {
      if (isEligibleParent(el)) last = el;
    });
    return last;
  }

  function matchGiftParent(giftEl, scope) {
    if (!giftEl || !scope) return null;
    return matchParent(
      scope,
      giftEl.getAttribute('data-gift-parent-key'),
      giftEl.getAttribute('data-gift-parent-variant'),
      false
    );
  }

  function prefersReducedMotion(node) {
    var view = viewOf(node);
    if (!view || typeof view.matchMedia !== 'function') return false;
    try {
      return !!view.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      return false;
    }
  }

  function canAnimate(node) {
    if (prefersReducedMotion(node)) return false;
    var proto = node && node.ownerDocument && node.ownerDocument.defaultView
      ? node.ownerDocument.defaultView.Element
      : (typeof Element !== 'undefined' ? Element : null);
    return !!(proto && proto.prototype && typeof proto.prototype.animate === 'function');
  }

  function readRect(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') {
      return { top: 0, left: 0, width: 0, height: 0 };
    }
    var rect = el.getBoundingClientRect();
    return { top: rect.top, left: rect.left, width: rect.width, height: rect.height };
  }

  function clearInline(el) {
    if (!el || !el.style) return;
    el.style.opacity = '';
    el.style.transform = '';
    el.style.height = '';
    el.style.overflow = '';
    el.style.pointerEvents = '';
  }

  function trackLive(el) {
    if (liveStyled.indexOf(el) === -1) liveStyled.push(el);
  }

  function inertGhost(node) {
    if (!node) return node;
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('data-native-gift-ghost', 'true');
    node.classList.add('native-cart-gift-ghost');
    if (node.style) node.style.pointerEvents = 'none';
    Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('[id]') : [], function (el) {
      el.removeAttribute('id');
    });
    Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('[name]') : [], function (el) {
      el.removeAttribute('name');
    });
    Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('[for]') : [], function (el) {
      el.removeAttribute('for');
    });
    Array.prototype.forEach.call(
      node.querySelectorAll ? node.querySelectorAll('button, input, select, textarea, a') : [],
      function (el) {
        if ('disabled' in el) el.disabled = true;
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      }
    );
    return node;
  }

  function cancelAnimations() {
    running.slice().forEach(function (anim) {
      try {
        if (anim && typeof anim.cancel === 'function') anim.cancel();
      } catch (err) {}
    });
    running = [];
    ghosts.forEach(function (ghost) {
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
    });
    ghosts = [];
    liveStyled.forEach(function (el) {
      clearInline(el);
    });
    liveStyled = [];
  }

  function trackAnim(anim, el) {
    if (!anim) return;
    running.push(anim);
    if (el) trackLive(el);
    var done = function () {
      var idx = running.indexOf(anim);
      if (idx !== -1) running.splice(idx, 1);
      clearInline(el);
    };
    if (typeof anim.addEventListener === 'function') {
      anim.addEventListener('finish', done);
      anim.addEventListener('cancel', done);
    } else {
      anim.onfinish = done;
      anim.oncancel = done;
    }
  }

  function ensureHome(mount) {
    if (!mount || !mount.parentNode) return null;
    if (mount.__nativeGiftHome && mount.__nativeGiftHome.parentNode) return mount.__nativeGiftHome;
    var doc = mount.ownerDocument;
    var marker = doc.createComment(HOME_MARK);
    if (mount.nextSibling) mount.parentNode.insertBefore(marker, mount.nextSibling);
    else mount.parentNode.appendChild(marker);
    mount.__nativeGiftHome = marker;
    return marker;
  }

  function moveOfferHome(form) {
    var mount = offerMount(form);
    if (!mount) return mount;
    var home = mount.__nativeGiftHome;
    if (home && home.parentNode) {
      home.parentNode.insertBefore(mount, home);
    }
    return mount;
  }

  function applyCompactTitle(gift) {
    if (!gift) return;
    var title = gift.getAttribute('data-gift-display-title');
    if (!title) return;
    var name = gift.querySelector('.cart__product-name');
    if (name) name.textContent = title;
  }

  function ensureGiftGlyph(gift) {
    if (!gift) return;
    var media = gift.querySelector('.cart__item--image');
    if (!media) return;
    if (media.querySelector('img')) return;
    if (media.querySelector('.' + GLYPH_CLASS)) return;
    var doc = gift.ownerDocument;
    var glyph = doc.createElement('span');
    glyph.className = GLYPH_CLASS;
    glyph.setAttribute('aria-hidden', 'true');
    glyph.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4" focusable="false" aria-hidden="true"><path d="M8 20h32v7H8zM11 27v15h26V27M24 20v22M24 20c-11 0-13-3-11-7 3-5 9 0 11 7Zm0 0c11 0 13-3 11-7-3-5-9 0-11 7Z"/></svg>';
    media.appendChild(glyph);
  }

  function groupGiftLines(form) {
    if (!isActiveNativeDrawer(form)) return;
    var products = productsRoot(form);
    if (!products) return;
    // Shopify accepts keyed updates on the HTML cart form as well as Ajax.
    // Moving a row must never change which line receives a submitted quantity.
    products.querySelectorAll('.js-qty__num[data-id]').forEach(function (input) {
      input.name = 'updates[' + input.getAttribute('data-id') + ']';
    });
    var gifts = [];
    collectItems(products).forEach(function (el) {
      if (isGiftLine(el)) gifts.push(el);
    });
    gifts.forEach(function (gift) {
      gift.classList.add('native-cart-gift-line');
      applyCompactTitle(gift);
      ensureGiftGlyph(gift);
      var parent = matchGiftParent(gift, products);
      if (parent && parent !== gift) parent.appendChild(gift);
    });
  }

  function placeOfferUnderParent(form) {
    if (!isActiveNativeDrawer(form)) return;
    var mount = offerMount(form);
    if (!mount) return;
    var offer = mount.querySelector('[data-caffeine-gift-box]');
    if (!offer) return;
    ensureHome(mount);
    var products = productsRoot(form);
    if (!products) return;
    var parent = matchParent(
      products,
      offer.getAttribute('data-parent-line-key'),
      offer.getAttribute('data-parent-variant-id'),
      true
    );
    if (!parent) return;
    parent.appendChild(mount);
  }

  function captureFocus(form) {
    var doc = form && form.ownerDocument;
    var active = doc && doc.activeElement;
    if (!active || !form.contains(active)) return null;
    if (active.hasAttribute && active.hasAttribute('data-caffeine-gift-box-add')) {
      return { type: 'offer-add' };
    }
    var qtyWrapper = active.closest && active.closest('.js-qty__wrapper');
    var qtyInput = qtyWrapper && qtyWrapper.querySelector('.js-qty__num[data-id]');
    if (qtyInput) return { type: 'qty', key: qtyInput.getAttribute('data-id') };
    return null;
  }

  function restoreFocus(form, snapshot) {
    var focus = snapshot && snapshot.focus;
    if (!focus || !form) return;
    if (focus.type === 'offer-add') {
      var add = form.querySelector('[data-caffeine-gift-box-add]');
      if (add && typeof add.focus === 'function') {
        add.focus();
        return;
      }
      var giftQty = form.querySelector('.cart__item[data-native-gift-line="true"] .js-qty__num');
      if (giftQty && typeof giftQty.focus === 'function') {
        giftQty.focus();
        return;
      }
      var parentQty = form.querySelector('.cart__item[data-native-gift-eligible="true"] .js-qty__num');
      if (parentQty && typeof parentQty.focus === 'function') parentQty.focus();
      return;
    }
    if (focus.type === 'qty') {
      var input = form.querySelector('.js-qty__num[data-id="' + attrEscape(focus.key) + '"]');
      if (input && typeof input.focus === 'function') {
        input.focus();
        return;
      }
      var offerAdd = form.querySelector('[data-caffeine-gift-box-add]');
      if (offerAdd && typeof offerAdd.focus === 'function') offerAdd.focus();
    }
  }

  function giftKeysIn(scope) {
    var keys = [];
    collectItems(scope).forEach(function (el) {
      if (isGiftLine(el)) keys.push(el.getAttribute('data-key'));
    });
    return keys;
  }

  function shouldAnimate(form, snapshot) {
    if (!snapshot || !snapshot.hasItems) return false;
    var products = productsRoot(form);
    var nextKeys = giftKeysIn(products);
    var prevKeys = snapshot.giftKeys || [];
    var added = nextKeys.some(function (key) { return prevKeys.indexOf(key) === -1; });
    var removed = prevKeys.some(function (key) { return nextKeys.indexOf(key) === -1; });
    var offerNow = !!(offerMount(form) && offerMount(form).querySelector('[data-caffeine-gift-box]'));
    return added || removed || (!!snapshot.offerPresent !== offerNow);
  }

  function animateEnter(el) {
    if (!el || !canAnimate(el)) return;
    var height = readRect(el).height;
    var from = { opacity: 0, transform: 'translateY(-8px)' };
    var to = { opacity: 1, transform: 'translateY(0)' };
    if (height > 0) {
      el.style.overflow = 'hidden';
      from.height = '0px';
      to.height = height + 'px';
    }
    trackAnim(el.animate([from, to], { duration: DURATION, easing: EASING }), el);
  }

  function animateExit(ghost, parent) {
    if (!ghost) return;
    ghosts.push(ghost);
    if (parent) parent.appendChild(ghost);
    if (!canAnimate(ghost)) {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      var idx = ghosts.indexOf(ghost);
      if (idx !== -1) ghosts.splice(idx, 1);
      return;
    }
    var height = readRect(ghost).height || (ghost.style && ghost.style.height) || 0;
    var from = { opacity: 1, transform: 'translateY(0)' };
    var to = { opacity: 0, transform: 'translateY(-8px)' };
    if (height) {
      ghost.style.overflow = 'hidden';
      from.height = (typeof height === 'number' ? height + 'px' : height);
      to.height = '0px';
    }
    var anim = ghost.animate([from, to], { duration: DURATION, easing: EASING });
    var remove = function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      var gidx = ghosts.indexOf(ghost);
      if (gidx !== -1) ghosts.splice(gidx, 1);
    };
    trackAnim(anim, ghost);
    if (typeof anim.addEventListener === 'function') anim.addEventListener('finish', remove);
    else anim.onfinish = remove;
  }

  function flipSurvivors(form, snapshot) {
    var products = productsRoot(form);
    if (!products || !snapshot || !snapshot.items) return;
    collectItems(products).forEach(function (el) {
      var key = el.getAttribute('data-key');
      var prev = snapshot.items[key];
      if (!prev) return;
      var next = readRect(el);
      var dy = prev.top - next.top;
      if (!dy || Math.abs(dy) < 1) return;
      if (!canAnimate(el)) return;
      trackAnim(el.animate(
        [{ transform: 'translateY(' + dy + 'px)' }, { transform: 'translateY(0)' }],
        { duration: DURATION, easing: EASING }
      ), el);
    });
  }

  function playMotion(form, snapshot) {
    if (!shouldAnimate(form, snapshot)) return;
    var products = productsRoot(form);
    var nextKeys = giftKeysIn(products);
    var prevKeys = snapshot.giftKeys || [];
    nextKeys.forEach(function (key) {
      if (prevKeys.indexOf(key) !== -1) return;
      var el = queryByKey(products, key);
      if (el) animateEnter(el);
    });
    prevKeys.forEach(function (key) {
      if (nextKeys.indexOf(key) !== -1) return;
      var prev = snapshot.items && snapshot.items[key];
      var markup = prev && prev.markup;
      if (!markup) return;
      inertGhost(markup);
      var layer = form.querySelector('.drawer__scrollable') || products;
      var layerRect = readRect(layer);
      markup.style.position = 'absolute';
      markup.style.top = (prev.top - layerRect.top + layer.scrollTop) + 'px';
      markup.style.left = (prev.left - layerRect.left + layer.scrollLeft) + 'px';
      markup.style.width = prev.width + 'px';
      markup.style.height = prev.height + 'px';
      markup.style.margin = '0';
      animateExit(markup, layer);
    });
    var mount = offerMount(form);
    if (!snapshot.offerPresent && mount && mount.querySelector('[data-caffeine-gift-box]')) {
      animateEnter(mount);
    }
    flipSurvivors(form, snapshot);
  }

  function beforeRefresh(form) {
    if (isActiveNativeDrawer(form)) cancelAnimations();
    var snapshot = {
      active: false,
      hasItems: false,
      items: {},
      giftKeys: [],
      offerPresent: false,
      reduced: prefersReducedMotion(form),
      focus: captureFocus(form)
    };
    if (!isActiveNativeDrawer(form)) return snapshot;
    snapshot.active = true;
    var products = productsRoot(form);
    collectItems(products).forEach(function (el) {
      var key = el.getAttribute('data-key');
      if (!key) return;
      snapshot.hasItems = true;
      snapshot.items[key] = readRect(el);
      if (isGiftLine(el)) {
        snapshot.giftKeys.push(key);
        snapshot.items[key].markup = el.cloneNode(true);
        snapshot.items[key].isGift = true;
      }
    });
    var mount = offerMount(form);
    snapshot.offerPresent = !!(mount && mount.querySelector('[data-caffeine-gift-box]'));
    if (mount) snapshot.offerRect = readRect(mount);
    moveOfferHome(form);
    return snapshot;
  }

  function afterRefresh(form, snapshot) {
    if (!isActiveNativeDrawer(form)) return;
    groupGiftLines(form);
    placeOfferUnderParent(form);
    restoreFocus(form, snapshot);
    playMotion(form, snapshot || {});
  }

  var api = {
    DURATION: DURATION,
    beforeRefresh: beforeRefresh,
    afterRefresh: afterRefresh,
    moveOfferHome: moveOfferHome,
    groupGiftLines: groupGiftLines,
    placeOfferUnderParent: placeOfferUnderParent,
    matchGiftParent: matchGiftParent,
    matchParent: matchParent,
    prefersReducedMotion: prefersReducedMotion,
    cancelAnimations: cancelAnimations,
    inertGhost: inertGhost,
    ensureHome: ensureHome
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  root.NativeCartGiftMotion = api;
})(typeof window !== 'undefined' ? window : globalThis);
